import makeTable from '../../components/makeTable.jsx';

export const PropertiesTable = makeTable([
  ['Icon', 10],
  ['Origin', 90],
]);
